function normalizeText(value) {
  return String(value || '').trim();
}

export function resolveSourceStatusMeta(status) {
  const labels = {
    uploaded: { bucket: 'queued', label: '等待解析', progress: 15 },
    parsing: { bucket: 'running', label: '解析中', progress: 35 },
    chunked: { bucket: 'running', label: '已切分，准备索引', progress: 55 },
    embedded: { bucket: 'running', label: '向量化中', progress: 75 },
    indexed: { bucket: 'running', label: '索引中', progress: 90 },
    ready: { bucket: 'completed', label: '可用于上下文', progress: 100 },
    duplicate: { bucket: 'duplicate', label: '重复资料', progress: 100 },
    failed: { bucket: 'failed', label: '处理失败', progress: 100 },
    error: { bucket: 'failed', label: '处理失败', progress: 100 },
  };
  return labels[normalizeText(status).toLowerCase()] || { bucket: 'running', label: '处理中', progress: 50 };
}

export function resolveUploadStageMeta(stage) {
  const labels = {
    reading: { bucket: 'running', label: '读取中' },
    uploading: { bucket: 'running', label: '上传中' },
    error: { bucket: 'failed', label: '上传失败' },
  };
  return labels[normalizeText(stage).toLowerCase()] || null;
}

export function formatSourceFallbackName(index) {
  return `资料 ${index + 1}`;
}

export function formatFallbackUploadName() {
  return '本地资料';
}

export function summarizeSourceQueueCounters(counters) {
  if (counters.running || counters.queued) {
    return `处理中 ${counters.running + counters.queued} 项 / 可用 ${counters.completed} 项`;
  }
  if (counters.failed) {
    return `失败 ${counters.failed} 项 / 可用 ${counters.completed} 项`;
  }
  if (counters.duplicate) {
    return `重复 ${counters.duplicate} 项 / 可用 ${counters.completed} 项`;
  }
  return `已收集 ${counters.completed} 份资料`;
}

export function formatSourceActivityHeadline(state, counters) {
  if (state === 'ingesting_sources') {
    return `正在处理 ${counters.running + counters.queued} 份资料`;
  }
  if (state === 'source_warning') {
    return `${counters.failed} 份资料处理失败`;
  }
  if (state === 'source_duplicate') {
    return `${counters.duplicate} 份重复资料`;
  }
  if (state === 'source_ready') {
    return `已收集 ${counters.completed} 份资料`;
  }
  return '';
}

export function formatSourceQueueHeader(counters) {
  return `Context 队列：${summarizeSourceQueueCounters(counters)}`;
}

export function formatSourceQueueItemLine(index, item) {
  const suffix = item.error ? `（${item.error}）` : '';
  return `${index + 1}. ${item.name}：${item.label}${suffix}`;
}

export function formatSourceQueueOverflowLine(count) {
  return `还有 ${count} 项资料在队列中`;
}

export function formatContextViewLine(viewLabel) {
  return `当前视图：${viewLabel}`;
}

export function formatSourceStateLine(headline) {
  return headline ? `资料状态：${headline}` : '资料状态：暂无队列活动';
}

export function formatCanvasLine(canvasLabel) {
  return `当前画布：${canvasLabel}`;
}

export function formatCanvasSyncLine(isSyncing) {
  return isSyncing ? '画布状态：正在同步上下文' : '画布状态：等待后端同步上下文';
}

export function resolveWorkspaceViewLabel(tabKey) {
  return normalizeText(tabKey).toLowerCase() === 'sources' ? '资料区' : '会话';
}
